var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.977 3.41C25.73 2.04648 24.553 1.05352 23.187 0.743516C21.143 0.31 17.36 0 13.267 0C9.17648 0 5.33297 0.31 3.28648 0.743516C1.92297 1.05352 0.743516 1.98352 0.496484 3.41C0.247032 4.96 0 7.13 0 9.92C0 12.71 0.247032 14.88 0.557032 16.43C0.806484 17.7935 1.98352 18.7865 3.34703 19.0965C5.51703 19.53 9.23703 19.84 13.33 19.84C17.423 19.84 21.143 19.53 23.313 19.0965C24.6765 18.7865 25.8535 17.8565 26.103 16.43C26.35 14.88 26.66 12.647 26.723 9.92C26.597 7.13 26.287 4.96 25.977 3.41ZM9.92 14.26V5.58L17.4835 9.92L9.92 14.26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.295fdb03994f1b534cc8e2b7beb53b1f.svg";
export { ForwardRef as ReactComponent };